'use client';

import { UserType, UserTypeToRoleMap } from '@baseball-near-you/common';
import { Separator, Skeleton } from '@baseball-near-you/ui';
import { RoleButton } from '@bb/components/Onboarding/steps';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { Fragment } from 'react';
import type { OnboardingStep } from './types';

export function RoleStep(props: {
  setCurrentStep: (step: OnboardingStep) => void;
  onStepSuccess: () => Promise<void>;
}) {
  const { userProfile, userProfileLoading } = useUserProfile();
  return (
    <div className="flex w-full flex-col">
      {userProfile ? (
        Object.entries(UserTypeToRoleMap).map(([type, role]) =>
          type === UserType.Personal ? (
            // personal users - choose athlete or parent
            role.map((r) => (
              <RoleButton
                role={r}
                type={type}
                onStepSuccess={props.onStepSuccess}
                key={type + r}
              />
            ))
          ) : (
            // team users - continue to next step
            <Fragment key={type}>
              <Separator className="mt-4" />
              <RoleButton
                type={type as UserType}
                label="Team associate"
                onStepSuccess={props.onStepSuccess}
              />
            </Fragment>
          )
        )
      ) : (
        <>
          <Skeleton className="h-12 w-full" />
          <Skeleton className="mt-4 h-12 w-full" />
          <Separator className="my-4" />
          <Skeleton className="h-12 w-full" />
        </>
      )}
    </div>
  );
}
